import React, { useState, useEffect } from 'react';
import { API } from '../../apis/api';
import { API_RESOURCE_URLS, TIME_DURATION } from '../../constants';
import {
  getDayWiseAsnTransitionGraphData,
  getWeekWiseAsnTransitionGraphData,
  asnTransitions,
} from '../../utils/graphDataUtils';
import MultiBarGraph from '../MultiBarGraph/MultiBarGraph';
import styles from './PlanVsActualGraphs.module.css';
import axios from 'axios';

const PlantVsActualGraphs = ({
  plant,
  line,
  durationText,
  startDateTime,
  endDateTime,
  ...props
}) => {
  const [lineOutPercentageGraphData, setLineOutPercentageGraphData] = useState(
    [],
  );
  const [percentageMaxCount, setPercentageMaxCount] = useState(0);

  const [rawData, setRawData] = useState([]);
  const [isGraphLoading, setIsGraphLoading] = useState(true);

  const fetchAsnTransitionStatisticsDataForGivenDateRange = async (
    selectedPlant,
    selectedLine,
    selectedStartDateTime,
    selectedEndDateTime,
    APICancelTokenSource,
  ) => {
    const response = await API.get(
      API_RESOURCE_URLS.ASN_TRANSITION_STATISTICS,
      {
        params: {
          plant: selectedPlant,
          line: selectedLine,
          from: selectedStartDateTime,
          to: selectedEndDateTime,
        },
        cancelToken: APICancelTokenSource.token,
      },
    );
    return response.data;
  };

  useEffect(() => {
    setIsGraphLoading(true);
    const cancelTokenSource = axios.CancelToken.source();
    fetchAsnTransitionStatisticsDataForGivenDateRange(
      plant,
      line,
      startDateTime,
      endDateTime,
      cancelTokenSource,
    )
      .then(res => setRawData(res))
      .then(setIsGraphLoading(false));
  }, [plant, line, startDateTime, endDateTime]);

  useEffect(() => {
    const [percentageMaxRecordCount, percentageGraphDataArray] =
      durationText === TIME_DURATION.LAST_SEVEN_DAYS
        ? getDayWiseAsnTransitionGraphData(rawData, startDateTime)
        : getWeekWiseAsnTransitionGraphData(rawData, startDateTime);

    setPercentageMaxCount(percentageMaxRecordCount);
    setLineOutPercentageGraphData(percentageGraphDataArray);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rawData]);

  return (
    <>
      <div>
        <div className={styles.innerGraphContainer}>
          <div className={styles.multiBarGraph}>
            <div className={styles.heading}>Plan vs Actual</div>
            <MultiBarGraph
              data={lineOutPercentageGraphData}
              maxRecordCount={percentageMaxCount}
              isLoading={isGraphLoading}
              durationText={durationText}
              keyFactors={asnTransitions}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default PlantVsActualGraphs;
